/**
 * Adiciona script ao documento
 * 
 * @param {String} src diretório do script 
 * @param {Boolean} options opções
 * @returns { HTMLElement }
 */
export const loadScript = (src, options={async: true}) => {
    try {
        
        const script = document.createElement('script');
        script.setAttribute('src', src);

        Object.keys(options).forEach(key => {
            script.setAttribute(key, options[key])
        });

        document.body.appendChild(script);

        return script;

    } catch(e) {
        console.error('LOAD SCRIPT:: ' + e);
    }    
}


/**
 * Adiciona link ao documento
 * 
 * @param {String} href href do link 
 * @param {Boolean} options opções
 * @returns { HTMLElement }
 */
export const loadLink = (href, options={async: true}) => {
    try {
        
        const link = document.createElement('link');
        link.setAttribute('href', href);

        Object.keys(options).forEach(key => {
            link.setAttribute(key, options[key])
        });

        document.head.appendChild(link);

        return link;

    } catch(e) {
        console.error('LOAD LINK:: ' + e);
    }    
}